import React from "react";
import { Flex, Text, Datepicker } from "@fluentui/react-northstar";
import { useState } from "react";
import TaskDetailsItem from "./TaskDetailsItem";
import styles from "./taskDetailsItem.module.scss";
import { constants } from "shared/constants";
import { pl as plLocale } from "date-fns/locale";
import format from "date-fns/format";
import EditConfirmationButtons, { EditConfirmationButtonsTypes } from "./EditConfirmationButtons";
import classNames from "classnames";
import { dateLocalizationStrings } from "utils/formattingUtils";

interface TaskDetailsEditableDateItemProps {
    label: string;
    date: Date;
    isMobile?: boolean;
    hidden?: boolean;

    onChange: (date: Date | [Date, Date] | null) => Promise<boolean>;
}

const TaskDetailsEditableDateItem: React.FC<TaskDetailsEditableDateItemProps> = (
    props: TaskDetailsEditableDateItemProps
) => {
    const [isInEditMode, setIsInEditMode] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [selectedDate, setSelectedDate] = useState<Date>(props.date);

    if (props.hidden) {
        return null;
    }

    return !isInEditMode ? (
        <TaskDetailsItem
            onClick={() => {
                setIsInEditMode(true);
            }}
            isLoading={isBusy}
            label={props.label}
            primaryTextColor="brand"
            primaryTextWeight="semibold"
            primaryText={format(props.date, constants.taskDetailsDateFormat, { locale: plLocale })}
            isMobile={props.isMobile}
        />
    ) : (
        <Flex className={classNames({ [styles.wrapper]: props.isMobile })}>
            <Flex className={styles.label}>
                <Text content={props.label} weight="bold" />
            </Flex>
            <Flex column>
                <Datepicker
                    className={styles.datePicker}
                    inputOnly
                    allowManualInput
                    {...dateLocalizationStrings}
                    selectedDate={selectedDate}
                    onDateChange={(event: any, data: any) => {
                        setSelectedDate(data.value as Date);
                    }}
                    formatMonthDayYear={(date: Date, strings: any) => {
                        return format(date, constants.taskDetailsDateFormat, { locale: plLocale });
                    }}
                />
                <EditConfirmationButtons
                    onAccept={async () => {
                        setIsBusy(true);
                        setIsInEditMode(false);

                        if (!(await props.onChange(selectedDate))) {
                            setSelectedDate(props.date);
                        }

                        setIsBusy(false);
                    }}
                    onCancel={() => {
                        setSelectedDate(props.date);
                        setIsInEditMode(false);
                    }}
                    buttons={[EditConfirmationButtonsTypes.Accept, EditConfirmationButtonsTypes.Cancel]}
                />
            </Flex>
        </Flex>
    );
};

export default TaskDetailsEditableDateItem;
